import LangEnum from '../../../lang/LangEnum';
import { LangEnumOption } from '../../../lib/OptionsLib';
import { CompactAvailability } from '../ProductTypes';

const productAvailabilityOptions: Array<LangEnumOption & { value: CompactAvailability }> = [
  { value: CompactAvailability.PRE_ORDER, label: LangEnum.GLOBAL_PRE_ORDER },
  { value: CompactAvailability.READY_FOR_DELIVERY, label: LangEnum.GLOBAL_READY_FOR_DELIVERY },
];

export default productAvailabilityOptions;
